import { Link } from "@mui/material";
import TkButton from "../../../components/atoms/TkButton";
import { IAPI_CHA001_Response } from "../../../type/apiType";

function getNewBodyList(
  threadList: IAPI_CHA001_Response["threadList"],
  nameClick: (user_id: string) => void,
  finishClick: (threadId: number) => void
) {
  const newBodyList = threadList?.map((item: any) => [
    {
      children: item.managerUserName,
      forSort: item.managerUserName,
    },
    {
      children: item.contractorNo,
      forSort: item.contractorNo,
    },
    {
      children: (
        <Link
          className="tkLikeLink"
          onClick={() => nameClick(item.contractorNo)}
        >
          {item.contractorName}
        </Link>
      ),
      forSort: item.contractorName,
    },
    {
      children: item.lastUpdatedDate,
      forSort: item.lastUpdatedDate,
      align: "center",
    },
    {
      children: !item.finishDate && (
        <TkButton onClick={() => finishClick(item.threadId)}>終了</TkButton>
      ),
      forSort: !!item.finishDate,
      align: "center",
    },
  ]);

  return newBodyList ?? [];
}

export { getNewBodyList };
